// Cookie consent preferences, stored only in this browser (no server log, no extra tracking).
export const CONSENT_VERSION = 1;
const KEY = 'intimate_consent';
export const CONSENT_EVENT = 'intimate-consent-changed';
export const OPEN_SETTINGS_EVENT = 'intimate-open-cookie-settings';

export const getConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || 'null');
    return c && c.version === CONSENT_VERSION ? c : null;
  } catch {
    return null;
  }
};

export const saveConsent = ({ statistics, session_recording }) => {
  const prev = getConsent();
  const next = {
    version: CONSENT_VERSION,
    date: new Date().toISOString(),
    statistics: !!statistics,
    session_recording: !!session_recording,
  };
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { prev, next } }));
  return next;
};

export const openCookieSettings = () => window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));

// Removes cookies set by third-party tools on our domain (GA4: _ga*, _gid; Clarity: _clck, _clsk, CLID).
export const clearThirdPartyCookies = (prefixes) => {
  const host = window.location.hostname;
  const domains = ['', host, `.${host}`, `.${host.split('.').slice(-2).join('.')}`];
  document.cookie.split(';').map((c) => c.split('=')[0].trim()).forEach((name) => {
    if (!prefixes.some((p) => name.startsWith(p))) return;
    domains.forEach((d) => {
      document.cookie = `${name}=; Max-Age=0; path=/${d ? `; domain=${d}` : ''}`;
    });
  });
};
